export { default as FAQInquiry } from "./main";

import * as Anchors from "./anchors";
import { default as routes } from "./routes";

export default {
  Anchors,
  routes,
};
